import React, { type ComponentProps, Suspense } from 'react'

import { Pictograms } from '../pictograms'
import type { Pictogram as PictogramType } from '../pictograms/directory'
import type { TextColorOverride } from '../TextColorOverride'
import { getLazyFallbackIconForSize } from '../utils/getLazyFallbackIconForSize'

type Props = {
  type: PictogramType
  color?: ComponentProps<typeof TextColorOverride>['color']
}

export function Pictogram({ color, type }: Props) {
  const Component = Pictograms[type]

  return (
    // We only have one version of pictogram so we hard code the size for now
    <Suspense fallback={getLazyFallbackIconForSize('100%')}>
      <Component color={color} />
    </Suspense>
  )
}
